import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBanner from '../../components/PageIntroBanner';
import PageSection from '../../components/PageSection';
import PageSectionContent from '../../components/PageSectionContent';
// import { colors } from '../../styles';

const styles = css`
 `;

function BuildOnYourLot({ page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${page.meta.name}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <div className={styles}>
        <PageIntroBanner
          headline={get(page, 'page_intro_banner[0].headline')}
          body={get(page, 'page_intro_banner[0].text')}
          image={get(page, 'page_intro_banner[0].photo.contentUrl')}
          videoThumbnail={get(page, 'page_intro_banner[0].video_thumbnail.contentUrl')}
          video={get(page, 'page_intro_banner[0].video_embed_code')}
        />
        {
          get(page, 'sections').length > 0 &&
          <PageSection>
            {
              page.sections.map(item => (
                <PageSectionContent
                  alternating
                  key={item.title}
                  preTitle={item.pre_title}
                  title={item.title}
                  body={item.body}
                  media={
                    <div style={{ backgroundImage: `url(${buildThumbnailUrl(item.image.contentUrl, { width: 1000, height: 1000, preserve: true })})` }} />
                  }
                />
              ))
            }
          </PageSection>
        }
      </div>
    </PageWrapper>
  );
}

BuildOnYourLot.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'build_on_your_lot',
})(BuildOnYourLot);



// WEBPACK FOOTER //
// ./src/pages/BuildOnYourLot/index.js